{
  "oneOf": {
    "O5EnvironmentV1AwsClusterCompute": {
      "ecs": "ECS",
      "eks": "EKS"
    },
    "O5EnvironmentV1ClusterProvider": {
      "aws": "AWS"
    },
    "O5EnvironmentV1CombinedConfigProvider": {
      "aws": "AWS"
    },
    "O5EnvironmentV1CustomVariableSrc": {
      "join": "Join",
      "value": "Value"
    },
    "O5EnvironmentV1EnvironmentProvider": {
      "aws": "AWS"
    },
    "O5EnvironmentV1RdsAuthType": {
      "iam": "IAM"
    }
  }
}